import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '@/assets/image/eng-lang.png'
import _imports_1 from '@/assets/image/thai-lang.png'


const _hoisted_1 = { class: "relative nav-login-container" }
const _hoisted_2 = {
  id: "nav",
  class: "nav-bar flex-center"
}
const _hoisted_3 = { class: "ml-auto flex-center" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  style: {"width":"3rem"},
  alt: "eng lang"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  alt: "thai lang",
  style: {"width":"3rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.lang == 'en')
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : (_openBlock(), _createElementBlock("img", _hoisted_5)),
        _createVNode(_component_el_select, {
          modelValue: _ctx.lang,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.lang) = $event)),
          class: "m-2 ml-12",
          placeholder: "Select"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              key: "en",
              label: _ctx.$t('english'),
              value: "en"
            }, null, 8, ["label"]),
            _createVNode(_component_el_option, {
              key: "th",
              label: _ctx.$t('thai'),
              value: "th"
            }, null, 8, ["label"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ])
  ]))
}